/** One decimal, or an em-dash when there is nothing to show. Never renders 0.0% for missing data. */
export const formatPercent = (value: number | null): string =>
  value === null ? '—' : `${value.toFixed(1)}%`;

/** Signed net scores carry no percent sign. */
export const formatSigned = (value: number | null): string =>
  value === null ? '—' : value.toFixed(1);
